import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import { Button } from "@material-ui/core";
import PaynlPinterminalSetup from "./PaynlPinterminalSetup";

export default function PaynlPinterminal(props) {
  const [setupIsOpen, setSetupIsOpen] = useState(false);

  if (props.paymentMethod.paynlPinTerminal) {
    return (
      <Box>
        Pinterminal connected: {props.paymentMethod.paynlPinTerminal.name}
        <Button
          variant={"outlined"}
          color={"secondary"}
          onClick={() => {
            props.updatePaynlPinterminal(null);
          }}
        >
          Remove pinterminal connection
        </Button>
      </Box>
    );
  } else {
    return (
      <Box>
        {!setupIsOpen && (
          <Button
            size={"small"}
            variant={"outlined"}
            color={"primary"}
            onClick={() => {
              setSetupIsOpen(true);
            }}
          >
            Connect PIN
          </Button>
        )}

        {setupIsOpen && <PaynlPinterminalSetup updatePaynlPinterminal={props.updatePaynlPinterminal} />}
      </Box>
    );
  }
}
